import React from 'react';

const FlipUp: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4662 8H10.665C10.1465 8 9.63547 8.12407 9.17467 8.36185C8.71387 8.59963 8.31666 8.94422 8.01621 9.36683C7.71575 9.78943 7.52077 10.2778 7.44756 10.7911C7.37435 11.3045 7.42503 11.8279 7.59537 12.3176L8.53988 11.9891L7.59537 12.3176L9.20525 16.9463C9.37579 17.4366 9.69477 17.8617 10.1179 18.1625C10.541 18.4634 11.0473 18.625 11.5665 18.625H22.875V16.625H11.5665C11.4627 16.625 11.3614 16.5927 11.2768 16.5325C11.1922 16.4723 11.1284 16.3873 11.0943 16.2892L10.1498 16.6178L11.0943 16.2892L9.48438 11.6606C9.41886 11.4723 9.39937 11.271 9.42753 11.0735C9.45569 10.8761 9.53068 10.6882 9.64624 10.5257C9.7618 10.3632 9.91457 10.2306 10.0918 10.1392C10.269 10.0477 10.4656 10 10.665 10H22.4662V8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2184 0.127014C10.6417 0.0979765 9.07508 0.383249 7.60985 0.966197C6.14348 1.5496 4.80811 2.41944 3.68179 3.52487C2.55546 4.63031 1.66077 5.94916 1.05002 7.40435C0.43927 8.85954 0.124702 10.4219 0.124706 12V14.9659C0.124706 17.3288 1.06334 19.5948 2.73413 21.2656C4.40491 22.9364 6.67098 23.875 9.03383 23.875H17.9427L17.954 23.8748C19.5404 23.839 21.0493 23.1822 22.1565 22.0456C23.2632 20.9094 23.8801 19.3844 23.8747 17.7984V12.0036C23.8967 8.88519 22.6827 5.88491 20.4982 3.65916C18.3138 1.43339 15.3367 0.163434 12.2184 0.127014ZM12.2033 1.12697L12.192 2.12684C14.7826 2.15629 17.2561 3.211 19.0708 5.06007C20.8856 6.90914 21.8938 9.40191 21.8747 11.9927L21.8747 12L21.8747 17.8002L21.8747 17.8039C21.8787 18.8667 21.4654 19.8887 20.7238 20.65C19.9847 21.4088 18.9783 21.8484 17.9196 21.875H9.03383C7.20142 21.875 5.44405 21.1471 4.14834 19.8514C2.85263 18.5557 2.12471 16.7983 2.12471 14.9659V12C2.1247 10.6877 2.38629 9.38846 2.89418 8.17835C3.40207 6.96825 4.14607 5.87152 5.0827 4.95226C6.01933 4.03301 7.1298 3.30967 8.3492 2.82452C9.5686 2.33938 10.8725 2.10216 12.1846 2.12673L12.2033 1.12697Z"
      />
    </svg>
  );
};

export default FlipUp;
